<template>
  <div id="app">
    <router-view
      v-if="isRouterAlive"
      :key="$route.name + ($route.query.room_id || '')"
    ></router-view>
    <div class="overlay" v-if="IsTan">
      <div style="position: relative;height: auto;width: auto;">
        <el-image :src="imgForm.image"> </el-image>
        <el-button
          class="but"
          size="mini"
          type="info"
          icon="el-icon-close"
          circle
          @click="close_alter"
        ></el-button>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div v-for="(item, i) in statusArr" :key="i">{{ item }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store/index";
import { initSideBar } from "@/views/sidebar/initConfig";
import {
  new_publicSet,
  pageSet,
  getmember_authorization_status,
} from "@/api/set";
import { TanKuang, setTanKuang } from "@/api/vip";

export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      dialogVisible: false,
      isRouterAlive: true,
      imgForm: {},
      IsTan: false,
      statusArr: [],
    };
  },
  watch: {
    $route: {
      handler() {
        this.get_image();
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    handleClose(done) {
      done();
    },
    async getTiXing() {
      const res = await getmember_authorization_status({
        app_id: store.getters.app_id,
      });
      if (res.code == 400) {
        this.dialogVisible = true;
        this.statusArr = res.data;
      }
      console.log(res);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    async close_alter() {
      this.IsTan = false;
      const res = await setTanKuang({
        app_id: store.getters.app_id,
        id: this.imgForm.article_id,
        alert: 0,
      });
    },
    getMessage() {
      let data = {
        token: store.getters.token,
        app_id: store.getters.app_id,
      };
      new_publicSet(data).then((res) => {
        console.log("sdsds", res);
        if (res.code == 200) {
          if (res.data) {
            store.commit("SET_PUBLICDATA", res.data);
          }
        }
      });
    },
    async configuration() {
      var data = {
        token: store.getters.token,
        app_id: store.getters.app_id,
      };
      const res = await pageSet(data);
      // debugger;
      if (res.code == 200) {
        if (
          res.data.pageLimit != "" &&
          res.data.pageLimit != null &&
          res.data.pageLimit
        ) {
          let pageArr = JSON.parse(res.data.pageLimit);
          if (pageArr.length > 0) {
            let pathArr = [];
            pageArr.forEach((element) => {
              let obj = {
                icon: "",
                name: this.pathName(element),
                path: "/apply/pageLimit/" + element,
              };
              pathArr.push(obj);
            });
            let status = pageArr.length != 0;

            store.commit("SET_PAGELIMIT", {
              status: status,
              pathData: [...pathArr],
            });
            if (status) {
              let inx = Number(sessionStorage.getItem("routerIdx")) || 0;
              store.commit("SET_NEWDATA", [...pathArr]);
              this.$router.push(pathArr[inx].path);
              sessionStorage.setItem("childRouter", "");
              sessionStorage.setItem("routerIdx", inx);
            } else {
              store.commit("SET_NEWDATA", initSideBar.vipData);
            }
          } else {
            store.commit("SET_NEWDATA", initSideBar.vipData);
          }
        } else {
          store.commit("SET_NEWDATA", initSideBar.vipData);
        }
      } else {
        store.commit("SET_NEWDATA", initSideBar.vipData);
      }
    },
    pathName(path) {
      switch (path) {
        case "oilsListNow":
          return "当前班次";
        case "getMoney":
          return "收银台";
        case "oilsList":
          return "消费订单";
        case "changeDuty":
          return "交班";
        case "voucherList":
          return "充值订单";
        case "ordinaryList":
          return "普通订单";
        case "shellIntegral":
          return "积分兑换";
        case "recharge":
          return "快速充值";
        case "integral":
          return "会员积分";
        case "scanVerification":
          return "现金待确认";
        case "userList":
          return "客户列表";
      }
    },

    async get_image() {
      const res = await TanKuang({ app_id: store.getters.app_id });
      if (res.code == 200) {
        console.log(typeof res.data);
        if (typeof res.data == "object") {
          if (typeof res.data.length != "number") {
            this.imgForm = res.data;
            this.IsTan = res.data.alert == 1;
          }
        }
        console.log(res);
      }
    },
  },
  async mounted() {
    console.log("store", store);
    await this.getMessage();
    await this.configuration();
    // this.getTiXing();
    // get_area({app_id:store.getters.app_id}).then(res=>{
    //   console.log('000999',res)
    // })
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}

body {
  margin: 0;
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  font-size: 12px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.numberInputStyle input[type="number"] {
  -moz-appearance: textfield;
}

.numberInputStyle input[type="number"]::-webkit-inner-spin-button,
.numberInputStyle input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.content {
  overflow-y: auto;
}
</style>
<style scoped>
.overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.but {
  opacity: 0.7;
  position: absolute;
  top: -18px;
  right: -18px;
}
</style>
